/* eslint-disable max-len */
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import AnimatedModel from '../../../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../../../components/ConfirmationPrompt'
import { convertToPatientTimeZoneDateFormat } from '../../../../../../CommonMethods/ConvertDatetoPatientTimezone'

const TableBody = ({
    tableData,
    indexNum,
    device
}) => {
    const [detailsModal,setDetailsModal] = useState(false);
    const [deviceDetails,setDeviceDetails] = useState()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    let date;

    date=convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)

    

    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <> 
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all" style={{lineBreak:'anywhere'}}>
                            {tableData?.reading_type==='spo2'?'SPO2':(tableData?.reading_type)?.split('_')?.map((word)=>word.charAt(0).toUpperCase()+word.slice(1)).join(' ')}
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.reading === undefined || tableData?.reading === "") ? "-" : tableData?.reading}
                         
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.alert_type === undefined || tableData?.alert_type === "") ? "-" : tableData?.alert_type}
                         
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.reading_details === undefined || tableData?.reading_details === "") ? "-" : tableData?.reading_details}
                         
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.threshold === undefined || tableData?.threshold === "") ? "-" : tableData?.threshold?.includes('/')?tableData?.threshold?.split('/')[0]+" / "+tableData?.threshold?.split('/')[1]:tableData?.threshold }
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all cursor-pointer'
                            onClick={()=>{
                                setDetailsModal(true); 
                                setDeviceDetails(tableData);
                            }}
                        >
                            {(tableData?.device_id === undefined || tableData?.device_id === "") ? "-" : tableData?.device_id}
                        </td>
                     
                    </>
                    
                }/>
            {detailsModal &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleClose={() => setDetailsModal(false)}
                        tittle= {'Details:'}
                        showingInfo={true}
                        deviceDetails={deviceDetails}
                    />
                }
            />
            }
        </>
    )
}

export default TableBody